import * as Yup from 'yup';

const settingSchema = Yup.object().shape({
  name: Yup.string().required('Name is required.'),
  value: Yup.string().required('Value is required.'),
  valueType: Yup.string().required('Type is required.'),
  language: Yup.string().required('Language is required.'),
});

export default settingSchema;